import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetSecurityEventConfigurationResData } from "./GetSecurityEventConfigurationResData";

const ENDPOINT = "/security/history/";

export class GetSecurityEventConfigurationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor(eventId: number) {
        super();
        this.endPoint += eventId.toString();
    }

    public async execute(): Promise<GetSecurityEventConfigurationResData> {
        let res = await this.executeCommand();
        return new GetSecurityEventConfigurationResData(res);
    }
}
